module.exports = __webpack_public_path__ + "static/media/Error.0d8920a8.svg";